<template>
  <div class="game-tr-step">
    <div
      v-if="stepData.audio && show"
      :style="setAudioStyle()"
      style="position: absolute; width: 100%; height: 100%; background: red; border-radius: 50%"
    >
      <div
        style="width: 100%; height: 100%; position: relative; cursor: pointer; left: 0"
        v-if="stepData.audio"
        @mouseenter="hoverOnIcon = true"
        @mouseleave="hoverOnIcon = false"
      >
        <img
          :src="audioOn"
          style="width: 100%; height: 100%; position: absolute; left: 0"
          v-if="!audioStatus && !hoverOnIcon"
          @click="startPlay()"
        />
        <img
          draggable="false"
          :src="audioOnHover"
          style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"
          v-if="!audioStatus && hoverOnIcon"
          @click="startPlay()"
        />
        <img
          :src="audioOff"
          style="width: 100%; height: 100%; position: absolute; left: 0"
          v-if="audioStatus && !hoverOnIcon"
          @click="startPlay()"
        />
        <img
          :src="audioOffHover"
          style="width: 100%; height: 100%; position: absolute; left: 0"
          v-if="audioStatus && hoverOnIcon"
          @click="startPlay()"
        />
      </div>
    </div>
    <div
      :id="'step_' + stepData.index"
      class="stepp-button"
      :class="{ 'stepp-button-anim': stepData.animation && animationState }"
      :style="setConfig()"
      @click="
        openPop($event, stepData.index);
        animationState = false;
      "
    >
      {{ stepData.id }}
    </div>
    <b-popover
      :target="'step_' + stepData.index"
      :ref="'step_' + stepData.index"
      :show.sync="show"
      triggers="click"
      :placement="stepData.direction"
    >
      <div
        class="popover-body-step-text"
        v-html="parseImagePaths(stepData.textObj.text)"
        :style="getStyle(stepData.textObj)"
      ></div>
    </b-popover>
  </div>
</template>

<script>
import _ from 'lodash';
import { Howler } from 'howler';
import * as utils from '../../../Utils/inputUtils';
export default {
  name: 'tr-step',
  components: {},
  props: {
    config: {
      type: null,
      default: function () {
        return {};
      },
    },
    stepData: {
      type: null,
      default: function () {
        return {};
      },
    },
    showStep: {
      type: null,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      audioStatus: false,
      audio: null,
      animationState: true,
      status: false,
      canIPlay: true,
      audioOn: null,
      audioOnHover: null,
      audioOff: null,
      audioOffHover: null,
      hoverOnIcon: false,
      // stepShowValue: this.showStep,
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.stepData.audio) {
        this.setAudioConfig(this.stepData.audio.src, 1);
        try {
          this.audioOn = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_ON;
          this.audioOnHover = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_ON_HOVER;
          this.audioOff = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_OFF;
          this.audioOffHover = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_OFF_HOVER;
        } catch {
          console.log(
            '%cAudioIcon TrSteo - error',
            'font-weight: bold; background: red; color: white; padding: 0px 10px'
          );
        }
      }
    },
    setAudioConfig(src, volume) {
      this.audio = new Howl({
        src: this.giveMeImagePlease(src),
        autoplay: false,
        loop: false,
        volume: volume || 1,
        onend: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onpause: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onstop: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onplay: () => {
          this.audioStatus = true;
          console.log('sztart');
        },
      });
      // this.startAudio();
    },
    parseImagePaths(text) {
      let paths = text.match(/src=".*?"/g),
        src = '';
      if (paths) {
        for (let path of paths) {
          src = path.substring(5, path.length - 1);
          text = text.replace(src, this.giveMeImagePlease(src));
        }
        return text;
      } else {
        return text;
      }
    },
    startPlay() {
      if (!this.audioStatus) {
        this.audio.play();
      } else {
        this.stopPlay();
      }
    },
    startAudio() {
      this.audio.play();
    },
    stopPlay() {
      this.audio.stop();
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    openPop($event, index) {
      this.show = !this.show;
      this.$emit('close-all', $event, { index: index });
      this.$emit('step-change', $event, { index: index, show: this.show });
      return this.show;
    },
    setConfig() {
      return {
        width: this.config.width + 'px',
        height: this.config.height + 'px',
        'font-size': this.config.fontSize + 'px',
        background: this.config.backgroundColor,
        color: this.config.color,
      };
    },
    setAudioStyle() {
      if (this.stepData.audio.position == 'top') {
        return {
          background: this.config.backgroundColor,
          top: -1 * this.config.height - 5 + 'px',
        };
      } else if (this.stepData.audio.position == 'bot') {
        return {
          background: this.config.backgroundColor,
          top: this.config.height + 5 + 'px',
        };
      } else if (this.stepData.audio.position == 'left') {
        return {
          background: this.config.backgroundColor,
          left: this.config.width - 5 + 'px',
        };
      } else if (this.stepData.audio.position == 'right') {
        return {
          background: this.config.backgroundColor,
          left: -1 * this.config.width + 5 + 'px',
        };
      }
      return {
        background: this.config.backgroundColor,
      };
    },
    getStyle(item) {
      item.width = item.width;
      item.height = item.height;
      return _.merge(this.getCustomStyle(item), {
        width: utils.elementWidth(item.width, 'px'),
        height: utils.elementHeight(item.height, 'px'),
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    show: {
      get() {
        return this.showStep.show;
      },
      set(newValue) {
        // if (!newValue) {
        //   // this.$emit('change');
        //   this.$refs['step_' + this.stepData.id].$emit('close');
        // }
        if (newValue == false) {
          if (this.audio) {
            this.stopPlay();
          }
        }
        this.showStep.show = newValue;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/inputBase';
@import '~@/assets/sass/variable';

.game-tr-step {
  .stepp-button {
    border-radius: 100%;
    width: 45px;
    height: 45px;
    font-size: 29px;
    background: $borderColor;
    // background: #f26f21;
    color: #fff;
    font-family: $stepByStepFontFamily;
    font-weight: bold;
  }
  .audio {
    border-radius: 50%;
    height: 57px;
    width: 57px;
    color: $secondIconColor;
    background-color: $firstIconColor;
    transition: 0.2s;
    &:hover {
      // background-color: rgb(40, 196, 36);
      color: $firstIconColor;
      background-color: $secondIconColor;
      // .audio-icon {
      //     color: $secondIconColor;
      //     background-color: $firstIconColor;
      // }
      .audio-svg-button {
        fill: #00a8ec;
      }
    }
    .audio-svg-button {
      width: 100%;
      height: 100%;
      fill: white;
      transition: 0.2s;
    }
  }
}
</style>
<style lang="scss">
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/inputBase';
@import '~@/assets/sass/variable';
.popover.bs-popover-auto[x-placement^='top'] .arrow::after,
.popover.bs-popover-top .arrow::after {
  border-top-color: #f5f5dc !important;
}
.popover.bs-popover-auto[x-placement^='left'] .arrow::after,
.popover.bs-popover-left .arrow::after {
  border-left-color: #f5f5dc !important;
}
.popover.bs-popover-auto[x-placement^='right'] .arrow::after,
.popover.bs-popover-right .arrow::after {
  border-right-color: #f5f5dc !important;
}
.popover.bs-popover-auto[x-placement^='bottom'] .arrow::after,
.popover.bs-popover-bottom .arrow::after {
  border-bottom-color: #f5f5dc !important;
}
.popover {
  // background-color: #f5f5dc;

  // .arrow::after {
  //
  // }
  .popover-body {
    font-size: 25px;
    font-family: $stepByStepFontFamily;
    padding: 0;
    background-color: #f5f5dc;
    // padding: 0.5rem 0.75rem;
    .popover-body-step-text {
      padding: 0.5rem 0.75rem;
      background-color: #f5f5dc;
      // background-color: red;
    }
  }
}
</style>
<style lang="sass">
.stepp-button-anim
  animation: 2s 0s pulseStepp 10 linear backwards

  @keyframes pulseStepp
    0%
      transform: scale(1)
    35%
      transform: scale(1.2)
    70%
      transform: scale(1)
</style>
